<div ngbDropdown class="d-inline-block activator" container="body">
  <i ngbDropdownToggle class="fa fa-ellipsis-v"></i>
  <div ngbDropdownMenu>
    @for (button of actions; track button) {
      <div>
        @if (button.visible) {
          <button
            ngbDropdownItem
            (click)="button.action()"
            >
            {{ button.label | translate }}
          </button>
        }
      </div>
    }
  </div>
</div>

